<template>
  <div>
    peer: {{ connection.peer }}<br />
    Label: {{ connection.label }}<br />
    Open: {{ connection.open }}<br />
    reliable: {{ connection.reliable }}<br />
    serialization: {{ connection.serialization }}<br />
    type: {{ connection.type }}<br />
    <v-textarea v-model="logsAsLines" label="Logs"></v-textarea>
    <v-text-field v-model="message" label="Message" outlined></v-text-field>
    <v-btn @click="send" :disabled="message.trim().length === 0">Send</v-btn>
    <v-btn @click="close" :disabled="!connection.open">Close</v-btn>
  </div>
</template>

<script>
export default {
  name: 'DataConnection',
  props: {
    connection: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      logs: [],
      message: '',
    };
  },
  computed: {
    logsAsLines() {
      return this.logs.join('\n');
    },
  },
  mounted() {
    this.connection.on('data', async (data) => {
      // await new Promise((resolve) => setTimeout(resolve, 5 * 1000));
      this.logs.push('Data: ' + data);
    });
    this.connection.on('error', (error) => {
      this.logs.push(error.toString());
    });
  },
  methods: {
    send() {
      this.connection.send(this.message);
      this.message = '';
    },
    close() {
      this.connection.close();
    },
  },
};
</script>

<style scoped></style>
